import React from 'react'

import { WebsiteThemeBase } from 'src/editor/website/styles/themes/website-theme-base'
import { WebsiteThemeDropdownGroupSection } from 'src/editor/website/styles/themes/website-theme-group-section'

export const WebsiteStylesSettingsThemesAndColors = () => {
  return (
    <>
      <WebsiteThemeBase />
      <WebsiteThemeDropdownGroupSection />
    </>
  )
}
